import React, { useState } from "react";
import { styled } from "../../stitches.config";
import SuccessIcon from "../assets/icons/success-icon.svg";

import { bodyLarge, h3 } from "../commonStyles/Fonts";

interface IUnsubscribeModalProps {
    onCloseBtn: () => void;
    onUnsubscribeBtn: () => Promise<boolean>;
    open: boolean;
}

const UnsubscribeModal: React.FC<IUnsubscribeModalProps> = ({ onCloseBtn, onUnsubscribeBtn, open }) => {

    const [isLock, setLock] = useState<boolean>(false);
    const [isUnsubscibe, setUnsubscribe] = useState<boolean>(false);

    const unsubscribe = () => {
        //setUnsubscribe(true);
        onUnsubscribeBtn().then(() => {
            setUnsubscribe(true);
        });
    };

    const closeModal = () => {
        if (!isLock && isUnsubscibe) {
            window.location.reload();
        }

        if (!isLock)
            return onCloseBtn();
    };

    if (!open) return (<></>);

    return (
        <Wrapper>
            <Box>
                <Header className={h3()}>
                    <p>{!isUnsubscibe ? "Czy na pewno chcesz zrezygnować z trybu Twoje naTemat?" : <><span></span> Tryb Twoje naTemat został wyłączony!</>}</p>
                    <CloseButton onClick={closeModal}>
                        <svg viewBox="0 0 20 21" xmlns="http://www.w3.org/2000/svg">
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M11.7525 10.4142L19.5455 2.62119L17.707 0.782715L9.91401 8.57568L2.12119 0.782868L0.282715 2.62135L8.07553 10.4142L0.282715 18.207L2.12119 20.0455L9.91401 12.2526L17.707 20.0456L19.5455 18.2071L11.7525 10.4142ZM9.91401 8.99995L17.707 1.20698L17.707 1.20703L9.91406 9L9.91401 8.99995ZM2.12119 1.20713L2.12124 1.20718L0.707031 2.6214L0.706979 2.62135L2.12119 1.20713ZM8.4998 10.4142L0.706979 18.207L0.707031 18.207L8.49985 10.4142L8.4998 10.4142Z" />
                        </svg>
                    </CloseButton>
                </Header>
                <Description className={bodyLarge()}>
                    {!isUnsubscibe ? (
                        <>
                            Treści w serwisie naTemat zawsze będą dostępne bez opłat, ale kontrybuując finansowo, możesz korzystać z portalu bez reklam a redakcji zapewniasz możliwość niezależnego tworzenia treści.
                        </>
                    ) : (
                        <>
                            Gdybyś chciał kiedyś oglądać treści naTemat całkowicie bez reklam i powrócić do wspierania naszej redakcji, możesz włączyć Twoje naTemat jeszcze raz.
                        </>
                    )}
                </Description>
                <div className={bodyLarge()}>
                    {!isUnsubscibe ? (
                        <>
                            <button
                                className="btn-red"
                                onClick={unsubscribe}
                            >
                                Tak, rezygnuję z Trybu Twoje naTemat
                            </button>
                            <button
                                className="btn-white"
                                onClick={closeModal}
                            >
                                Nie chcę rezygnować
                            </button>
                        </>
                    ) : (
                        <>
                            <button
                                className="btn-black"
                                onClick={closeModal}
                            >
                                Zamknij
                            </button>
                        </>
                    )}
                </div>
            </Box>
        </Wrapper>
    );

};

const Wrapper = styled("div", {
    position: "fixed",
    zIndex: "2000000",
    background: "rgba(0,0,0,0.75)",
    width: "100vw",
    height: "100vh",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    top: 0,
    left: 0,
    color: "$grayscale100",
});

const Box = styled("div", {
    maxWidth: "408px",
    background: "$grayscale0",
    opacity: "1",
    padding: "32px 16px 40px 16px",
    margin: " 0 20px",
    "@bp3": {
        margin: 0,
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%,-50%)",
    },
    "@bp4": {
        padding: "24px 32px 32px 32px",
    },
    "& button": {
        padding: "11px 0 13px 0",
        width: "100%",
        borderWidth: "0px",
    },
    ".btn-red": {
        background: "$aszdziennikPrimary",
        color: "$grayscale0Fixed",
        padding: "11px 0 13px 0",
        width: "100%",
        borderWidth: "0px !important",
        fontSize: "16px",
        "&:hover": {
            borderWidth: "0px !important",
        }
    },
    ".btn-white": {
        background: "$grayscale0",
        color: "$grayscale100",
        marginTop: "13px",
    },
    ".btn-black": {
        background: "$grayscale100Fixed",
        color: "$grayscale0Fixed"
    },
});

const Header = styled("div", {
    display: "flex",
    justifyContent: "space-between",
    "& p": {
        margin: 0,
        maxWidth: "300px",
        fontWeight: "600",
        color: "$grayscale100",
    },
    "& span": {
        display: "block",
        width: "44px",
        height: "44px",
        marginBottom: "24px",
        backgroundImage: `url("${SuccessIcon}")`,
        backgroundSize: "cover",
    }
});

const Description = styled("div", {
    margin: "32px 0",
});

const CloseButton = styled("button", {
    border: "none",
    background: "none",
    width: "16px !important",
    height: "16px",
    padding: "0",
    lineHeight: 0,
    img: {
        width: "100%",
        height: "100%",
    },
    "svg": {
        fill: "$grayscale100",
        width: "16px",
        height: "16px",
    }
});


export default UnsubscribeModal;
